var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayGpay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_117_6965)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9355 27.8285V31.5303H25.7607V22.3892H28.8751C29.6644 22.3892 30.3374 22.6523 30.8881 23.1785C31.451 23.7047 31.7324 24.3471 31.7324 25.1058C31.7324 25.8828 31.451 26.5253 30.8881 27.0453C30.3435 27.5654 29.6705 27.8224 28.8751 27.8224H26.9355V27.8285ZM26.9355 23.515V26.7027H28.8996C29.3646 26.7027 29.7562 26.5437 30.0621 26.2316C30.3741 25.9195 30.5332 25.5402 30.5332 25.1119C30.5332 24.6897 30.3741 24.3165 30.0621 24.0045C29.7561 23.6802 29.3707 23.5211 28.8996 23.5211H26.9355V23.515Z",
    fill: "#383E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8041 25.0693C35.6729 25.0693 36.3582 25.3018 36.8599 25.7668C37.3616 26.2318 37.6124 26.8681 37.6124 27.6758V31.5305H36.4928V30.6617H36.4438C35.9604 31.3776 35.3119 31.7325 34.5043 31.7325C33.8129 31.7325 33.2377 31.5305 32.7727 31.1206C32.3077 30.7106 32.0752 30.2028 32.0752 29.591C32.0752 28.9424 32.3199 28.4285 32.8094 28.0491C33.2989 27.6636 33.9536 27.474 34.7674 27.474C35.4649 27.474 36.0401 27.6025 36.4867 27.8594V27.5902C36.4867 27.1803 36.3276 26.8376 36.0033 26.5501C35.679 26.2625 35.2997 26.1218 34.8653 26.1218C34.2106 26.1218 33.6905 26.3971 33.3111 26.9539L32.2771 26.3053C32.8461 25.4793 33.6905 25.0693 34.8041 25.0693ZM33.2867 29.6093C33.2867 29.9152 33.4152 30.1722 33.6783 30.3741C33.9353 30.576 34.2412 30.68 34.5899 30.68C35.0856 30.68 35.5261 30.4965 35.9116 30.1293C36.2971 29.7622 36.4928 29.3339 36.4928 28.8383C36.1257 28.5508 35.6179 28.4039 34.9632 28.4039C34.4859 28.4039 34.0883 28.5201 33.7701 28.7465C33.4458 28.9851 33.2867 29.2728 33.2867 29.6093Z",
    fill: "#383E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0003 25.271L40.0844 34.2775H38.8729L40.3291 31.1264L37.7471 25.271H39.0258L40.8859 29.762H40.9104L42.7214 25.271H44.0003Z",
    fill: "#383E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1649 25.98H17.2407V27.9991L20.0767 27.9997C19.9617 28.6715 19.5915 29.2442 19.0243 29.626V29.6264C19.0245 29.6263 19.0247 29.6262 19.0249 29.626L18.9738 30.8329L20.713 30.9354C20.7128 30.9356 20.7125 30.9359 20.7123 30.936C21.698 30.0238 22.2628 28.6752 22.2628 27.082C22.2628 26.6989 22.2285 26.3324 22.1649 25.98Z",
    fill: "#0085F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0246 29.6263C19.0244 29.6265 19.0242 29.6266 19.024 29.6267C18.5542 29.9434 17.9492 30.1287 17.2417 30.1287C15.8742 30.1287 14.7141 29.2072 14.2987 27.9652H14.2985C14.2986 27.9653 14.2986 27.9656 14.2987 27.9658L12.8467 27.7358L12.5576 29.3165C13.4204 31.0283 15.1934 32.2028 17.2417 32.2028C18.6572 32.2028 19.8464 31.7375 20.7121 30.9363C20.7124 30.9361 20.7126 30.9359 20.7128 30.9357L19.0246 29.6263Z",
    fill: "#00A94B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1347 26.9627C14.1347 26.6139 14.1929 26.2768 14.2987 25.9599L13.8454 24.6089H12.5574C12.2007 25.3168 12 26.1159 12 26.9627C12 27.8095 12.2013 28.6086 12.5574 29.3165L12.5576 29.3163L14.2987 27.9655C14.2987 27.9653 14.2986 27.9651 14.2986 27.9649C14.1928 27.6482 14.1347 27.3113 14.1347 26.9627Z",
    fill: "#FFBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.242 21.7222C15.1941 21.7222 13.4204 22.8969 12.5576 24.6089L14.2989 25.9599C14.7144 24.7179 15.8744 23.7964 17.2419 23.7964C18.0147 23.7964 18.7067 24.0626 19.2531 24.5827L20.7491 23.0879C19.8406 22.2416 18.656 21.7222 17.242 21.7222Z",
    fill: "#FF4031"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_117_6965",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_117_6965"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_117_6965",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayGpay);
export default __webpack_public_path__ + "static/media/pay-gpay.e06874135f55d36c2aa09821502ebbdb.svg";
export { ForwardRef as ReactComponent };